import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Main.module.scss";
import CookieForm from "../common/CookieForm.js";
import { ConnectedChainProvider } from "../../contexts/ConnectedChainProvider.js";
import { IsChainSupportedProvider } from "../../contexts/IsChainSupportedProvider.js";
import { IsConnectedProvider } from "../../contexts/IsConnectedProvider.js";
import { IsWeb3AvailableProvider } from "../../contexts/IsWeb3AvailableProvider.js";
import { SupportedChainProvider } from "../../contexts/SupportedChainProvider.js";
import { WindowWidthProvider } from "../../contexts/WindowWidthProvider.js";
import Header from "./header/Header.js";
import Footer from "./Footer.js";
import { scrollToAnchor } from "../../../lib/html.js";

export default function Main({children}) {
	const scrollDelay = 1500;

	const location = useLocation();

	useEffect(() => {
		const timeoutId = setTimeout(() => {
			scrollToAnchor();
		}, scrollDelay);
	
		return () => clearTimeout(timeoutId);
	}, [location]);

    return (
		<IsWeb3AvailableProvider>
			<ConnectedChainProvider>
				<IsChainSupportedProvider>
					<IsConnectedProvider>
						<SupportedChainProvider>
							<WindowWidthProvider>
								<Header/>
								
								<main className={styles.main}>
									<div className={styles.container}>
										{children}
									</div>
								</main>

								<CookieForm/>

								<Footer/>
							</WindowWidthProvider>
						</SupportedChainProvider>
					</IsConnectedProvider>
				</IsChainSupportedProvider>
			</ConnectedChainProvider>
		</IsWeb3AvailableProvider>
    );
}